import moment from "moment-timezone";
import { TimezoneOption } from "@platform/features/timezones/timezones.types";
import { TimeslotId, Timeslot } from "../timeslots.types";
import { packTimeslotDateData } from "./packTimeslotDateData";

export const makeTimeslotFromId = (
  timeSlotId: number,
  startDate: string,
  timezone: TimezoneOption
): Timeslot => {
  const id = timeSlotId as TimeslotId;

  // Each day has 48 slots
  const utcDayIndex = Math.floor(id / 48);
  const remainingSlots = id % 48;

  const utcHour = Math.floor(remainingSlots / 2);
  const utcMinute = remainingSlots % 2 === 0 ? 0 : 30;

  // Build UTC start and end datetimes anchored to a reference week
  const utcStart = moment
    .utc(startDate)
    .startOf("week") // anchor to Sunday 00:00 UTC
    .add(utcDayIndex, "days")
    .add(utcHour, "hours")
    .add(utcMinute, "minutes");

  const utcEnd = utcStart.clone().add(30, "minutes");

  // Convert to local timezone
  const localStart = utcStart.clone().tz(timezone.name);
  const localEnd = utcEnd.clone().tz(timezone.name);

  return {
    id,
    local: {
      start: packTimeslotDateData(localStart),
      end: packTimeslotDateData(localEnd),
    },
    utc: {
      start: packTimeslotDateData(utcStart),
      end: packTimeslotDateData(utcEnd),
    },
  };
};

export default makeTimeslotFromId;
